import * as Cognito from '../../infrastructure/aws/cognito/cognito';

export default class Session {
  static async getSession() {
    const res = await Cognito.getSession();
    return res;
  }
}
